/**
 * TanStack Query hooks for `pricing-page`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pricingPageQueryKeys,
	type CreatePricingPageBody,
	type ListPricingPageResponse,
	type PricingPageRow,
} from "./api";

export function usePricingPageList(): UseQueryResult<ListPricingPageResponse, Error> {
	return useQuery({
		queryKey: pricingPageQueryKeys.list(),
		queryFn: list,
	});
}

export function usePricingPageCreate(): UseMutationResult<PricingPageRow, Error, CreatePricingPageBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pricingPageQueryKeys.all });
		},
	});
}

export function usePricingPageDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pricingPageQueryKeys.all });
		},
	});
}
